/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* globals SnapABug, SnapEngage */

import loadScript from '@bt-react/libs/loadScript'
import snapEngageConfig from './SnapEngageConfig'

import { interval, Subject } from 'rxjs'
import { startWith, distinctUntilChanged } from 'rxjs/operators'
import state from './drawerState'

const INTERVAL_DURATION = 120000 // milliseconds = 2 minutes
const TYPE = 'chat'

const chat = {

  load: (success) => {

    const config = snapEngageConfig()
    loadScript.get(config.url, () => {

      // @ts-ignore
      SnapABug.initAsync(config.key)
      // @ts-ignore
      SnapABug.setChatFormPosition('br')

      success()

    })

  },

  agentSubject: new Subject(),

  agentStatus$ () {

    interval(INTERVAL_DURATION)
      .pipe(startWith(0))
      .subscribe(
        () => {

          this.updateAgents()

        }

      )

    return this.agentSubject.asObservable().pipe(distinctUntilChanged())

  },

  updateAgents () {

    // @ts-ignore
    SnapEngage.getAgentStatusAsync(
      online => this.agentSubject.next(online)
    )

  },

  drawerStatus$ () {

    const subject = new Subject()

    // @ts-ignore
    SnapEngage.setCallback('Open', function (status) {

      subject.next({ type: TYPE, status: state.OPEN })

    })

    // @ts-ignore
    SnapEngage.setCallback('Minimize', (isMinimized, b, c) => {

      subject.next({ type: TYPE, status: isMinimized ? state.MIN : state.OPEN })

      const minimizeButton = document.getElementById('designstudio-minimize')

      if (isMinimized) {

        // SnapEngage have an animation on hiding their UI - so we need to wait till it concludes to check if we are really minimized or closed
        setTimeout(() => {

          if (minimizeButton!.style!.display !== 'inline') {

            subject.next({ type: TYPE, status: state.CLOSED })
            this.updateAgents()

          }

        }, 800)

      }

    })

    // @ts-ignore
    SnapEngage.setCallback('Close', () => {

      subject.next({ type: TYPE, status: state.CLOSED })
      this.updateAgents()

    })

    return subject.asObservable().pipe(distinctUntilChanged())

  }

}

export default chat
